import { FF_WORKFLOW_COMMUNITY_PUBLISHING } from '@/consts/featureFlags';
import { useFeatureFlag } from '@/hooks/useFeatureFlag';
import { useUserWorkflowRole } from '@/state/workflow.state';

export const useCanPublishToCommunity = (): boolean => {
  const { value: isPublishToCommunityEnabled } = useFeatureFlag(FF_WORKFLOW_COMMUNITY_PUBLISHING);
  const role = useUserWorkflowRole();

  if (isPublishToCommunityEnabled !== true) return false;
  if (role !== 'editor') return false;
  // TODO: https://app.asana.com/1/10497086658021/project/1213153591111225/task/1214234289122439
  return true;
};
